import { useState, useEffect, useCallback } from "react";
import { INicheOption } from "../types";
import { apiMain, apiNiches } from "@/common/services";
import { useFetch } from "@/common/hooks/useFetch";

interface IUseNicheData {
  gifId: string;
  tags: string[];
  preferences: string[];
}

export const useNicheData = ({ gifId, tags: gifTags, preferences: gifPreferences }: IUseNicheData) => {
  const [nicheFields, setNicheFields] = useState<INicheOption[]>([]);
  const [suggestNicheFields, setSuggestedNicheFields] = useState<INicheOption[]>([]);

  const fetchGifNiches = useCallback(() => apiMain.getGifNiches(gifId), [gifId]);
  const fetchGifSuggestedNiches = useCallback(() => apiNiches.getGifSuggestedNiche(gifId), [gifId]);

  const { isLoading: gifNichesLoading, error, data: nichesData } = useFetch(fetchGifNiches);
  const { isLoading: gifSuggestedNichesLoading, error: suggestError, data: suggestedNichesData } = useFetch(fetchGifSuggestedNiches);

  useEffect(() => {
    if (nichesData) {
      const updatedNicheFields = nichesData.niches.map((niche) => ({
        ...niche,
        matchedTagsAndPrefs: niche.tags?.some((tag) => gifTags.includes(tag)) && niche.preferences?.some((pref) => gifPreferences.includes(pref)),
        isChecked: !!niche.added
      } as INicheOption));

      handleSetNicheFiled(updatedNicheFields);
    }
  }, [nichesData]);

  useEffect(() => {
    if (suggestedNichesData) {
      const updatedNicheFields = suggestedNichesData.niches.map((niche) => ({
        ...niche,
        matchedTagsAndPrefs: true,
        added: false,
        available: true,
        isChecked: false
      } as INicheOption));

      handleSetSuggestedNicheFiled(updatedNicheFields);
    }
  }, [suggestedNichesData]);

  const handleSetNicheFiled = (fields: INicheOption[]) => {
    setNicheFields(fields);
  };

  const handleSetSuggestedNicheFiled = (fields: INicheOption[]) => {
    setSuggestedNicheFields(fields);
  };

  return {
    nicheFields,
    suggestNicheFields,
    handleSetNicheFiled,
    handleSetSuggestedNicheFiled,
    myNichesLoading: gifNichesLoading,
    gifSuggestedNichesLoading,
    error,
    suggestError,
  };
};
